import React from 'react';
import { AuthValidation } from '@src/features/customers/auth/legacy/styled/AuthStyled';
import { useFieldError } from '@src/features/customers/hooks/useFieldError';
import { InputArea, InputLabel } from '@src/features/customers/auth/legacy/styled/InputStyled';
import OTPInput from 'otp-input-react';
import styled from 'styled-components';
import { LayoutColors } from '@src/core/theme';

interface InputProps {
  label?: string;
  codeOTP?: string;
  setCodeOTP: (code: string) => void;
  errorContext?: string;
  issetError?: boolean;
  className?: string;
}
const InputCode = ({ label, errorContext, codeOTP, setCodeOTP, className }: InputProps) => {
  const name = 'code';
  const errorMessage = useFieldError(errorContext, name);

  const borderError = errorMessage ? { borderColor: LayoutColors.errorDark } : {};

  return (
    <InputArea className={className}>
      <InputLabel>{label}</InputLabel>
      <OTPInputAttribute
        value={codeOTP}
        onChange={setCodeOTP}
        autoFocus
        OTPLength={6}
        inputStyles={{
          width: '100%',
          padding: '0',
          margin: '0',
          borderRadius: '4px',
          border: `1px solid ${LayoutColors.blackLight}`,
          ...borderError,
        }}
      />
      <AuthValidation>{errorMessage}</AuthValidation>
    </InputArea>
  );
};

const OTPInputAttribute = styled(OTPInput)`
  display: grid;
  gap: 7px;
  grid-template-columns: repeat(6, auto);
  justify-content: space-between;
`;

export default InputCode;
